import { Component, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { PromotionsService } from '../../promotions.service';

@Component({
  selector: 'app-loyalty-rewards-configuration-smart',
  template: `<app-loyalty-rewards-configuration [tiers]="tiers" [countries]="countries" [codeGroups]="codeGroups" [loyalityRewardsData]="loyalityRewardsData"></app-loyalty-rewards-configuration>`,
  styles: [
  ]
})
export class LoyaltyRewardsConfigurationSmartComponent extends FeaturesBaseComponent implements OnInit {
  loyalityRewardsData: any = [];
  codeGroups: any[] = [];
  countries: any[] = [];
  tiers: any[] = [];
  constructor(private promotionService: PromotionsService) {
    super();

    this.getAllData()

  }
  getAllData() {

    // Get all loyalty rewards data
    this.promotionService.getAllLoyaltyRewards().subscribe(res => {
      
      this.loyalityRewardsData = res['data'];
    });


    //Get list of countries
    this.promotionService.getCarrierCountries()
      .subscribe(arg => this.countries = arg['data']);

    //Get list of code groups

    this.promotionService.getcodeGroups().subscribe(
      res => this.codeGroups = res['data']
    )

    //Get list of Tiers

    this.promotionService.getTiers().subscribe(
      res => this.tiers = res['data']
    )

  }

  ngOnInit(): void {
    super.ngOnInit()
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

}
